import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

// SETUP COLORS

const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
};

export const PRIMARY = {
  lighter: "#C8FACD",
  lightBlue:"#cfddee",
  light: "#FFFFFF",
  main: "#0F5E7D",
  darker: "#005249",
  contrastText: "#FFFFFF",
  orange: "#FF891C",
  lightOrange: "#fffaf6",
  green: "#53A451",
  darkgreen: "#679437",
  lightGreen: "#f8fbf8",
  blue: "#1056AB",
  gray: "#e8ecf1",
  black: "#2E3142",
  lightBlack: "#222222",
  Red: "#CB444A",
  purple: "#A471FF",
  lightPurple: "#fbf9ff",
  red: "#ff5454",
  lightRed: "#fff8f8",
  lightGray: "#868686",
  skyBlue: "#41ADED",
  greendark: "#67943733",
  orangelight: "#FF6623",
  mediumBlue:"#3F51B3",
  blueLight:"#ECEEF8",
  plum:"#9A27AF",
  plumlight:"#F5EAF7",
  dodgerBlue:"#2196F1",
  shadesBlue:"#E9F5FE"
};

const SECONDARY = {
  lighter: "#D6E4FF",
  light: "#84A9FF",
  main: "#3366FF",
  dark: "#1939B7",
  darker: "#091A7A",
  contrastText: "#FFFFFF",
};

const INFO = {
  lighter: "#CAFDF5",
  light: "#61F3F3",
  main: "#00B8D9",
  dark: "#006C9C",
  darker: "#003768",
  contrastText: "#FFFFFF",
};

const SUCCESS = {
  lighter: "#D8FBDE",
  light: "#86E8AB",
  main: "#36B37E",
  dark: "#1B806A",
  darker: "#0A5554",
  contrastText: "#FFFFFF",
};

const WARNING = {
  lighter: "#FFF5CC",
  light: "#FFD666",
  main: "#FFAB00",
  dark: "#B76E00",
  darker: "#7A4100",
  contrastText: GREY[800],
};

export const ERROR = {
  lighter: "#FFE9D5",
  light: "#FFAC82",
  main: "#FF5630",
  dark: "#FF5630",
  darker: "#7A0916",
  contrastText: "#FFFFFF",
};

export const COMMON = {
  common: { black: "#000000", white: "#FFFFFF" },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  action: {
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default function palette(themeMode) {
  const light = {
    ...COMMON,
    mode: "light",
    text: {
      primary: "#1A4570",
      secondary: "#000",
      disabled: "#868686",
      light: "#fff",
    },
    background: {
      paper: "#fff",
      default: "#fff",
      neutral: "#fff",
      primary: "#1A4570",
    },
    action: {
      ...COMMON.action,
      active: "#fff",
    },
  };

  const dark = {
    ...COMMON,
    mode: "dark",
    text: {
      primary: "#FFFFFF",
      secondary: GREY[500],
      disabled: GREY[600],
    },
    background: {
      paper: GREY[800],
      default: GREY[900],
      neutral: alpha(GREY[500], 0.16),
    },
    action: {
      ...COMMON.action,
      active: GREY[500],
    },
  };

  return themeMode === "light" ? light : dark;
}
